module.exports = __webpack_public_path__ + "static/media/front.7d812ba9.jpg";